import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I made $730 by selling an unfinished book for 3 days.",
  "description": "",
  "published": "2012-11-20T00:00:00.000Z",
  "redirect_from": ["/blog/i-made-730-by-selling-an-unfinished-book-for-3-days/swizec/5585"],
  "categories": "Business, Github, HackerNews, Publishing, Reddit, Self-publishing, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Saturday afternoon I decided I was ready to unleash `}<a parentName="p" {...{
        "href": "https://leanpub.com/nightowls"
      }}>{`my book`}</a>{` on the world. Or rather, the 0.1 extremely unfinished draft version of the book.`}</p>
    <blockquote>
      <p parentName="blockquote">{`How finished do you consider it ? I'm counting 16 pages of actual content. I'm expecting a book to be a bit more work than a long blog post. /../`}</p>
      <p parentName="blockquote">{`I understand that you would like to have money early to fund the process, but releasing drafts is not a good idea. And this $3.14 `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Price_point",
          "title": "Price point"
        }}>{`price point`}</a>{` is not serious.`}</p>
      <p parentName="blockquote"><em parentName="p">{`~ A `}<a parentName="em" {...{
            "href": "http://reddit.com/",
            "title": "Reddit"
          }}>{`Reddit`}</a>{` commenter`}</em></p>
      <p parentName="blockquote">{`Why is the price capped at $10? I'm sure there are people who'd be willing to pay more`}</p>
      <p parentName="blockquote"><em parentName="p">{`~ A HN commenter`}</em></p>
    </blockquote>
    <p>{`Consider a book that's about 6000 words long, most chapters are just outlines and the most developed chapter is missing two important sections. Selling this almost sounds like a bad joke.`}</p>
    <p>{`However, after a few weeks of work and estimated reading time breaching the 30 minute mark, it was time to run the next experiment in the series - `}<em parentName="p">{`will people part with money for this?`}</em></p>
    <p>{`Using Leanpub allows me to run this sort of experiment with a clear conscience. People pay however much they want and they're getting future updates for free - they are basically paying for a future finished book.`}</p>
    <p>{`Set the minimum price at `}<em parentName="p">{`\\`}{`\\`}{`\\`}{`\\`}{`$1.73,`}</em>{` the suggested price at `}<em parentName="p">{`\\`}{`\\`}{`\\`}{`\\`}{`$3.14`}</em>{` click publish, create a few coupons, post to reddit and twitter and away we go!`}</p>
    <p>{`Mentally, I drew a line in the sand at 10 sales. That would let me know this book is worth my time.`}</p>
    <p><strong parentName="p">{`883 readers`}</strong>{` and `}<em parentName="p"><strong parentName="em">{`272 sales`}</strong></em>{` later ... oh boy!`}</p>
    <p>{`The book reached frontpage for several hours both on r/programming and on `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`HackerNews`}</a>{`, amounting to a total of 23,203 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Unique_user",
        "title": "Unique user"
      }}>{`unique visitors`}</a>{` and 28k pageviews.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/nightowls-histogram.png",
        "alt": "Histogram of readers vs. $ paid",
        "title": "Histogram of readers vs. $ paid"
      }}></img></p>
    <p>{`HN referrred just over 8000 visitors, who used HN's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Coupon",
        "title": "Coupon"
      }}>{`promo code`}</a>{` `}<em parentName="p">{`240 times`}</em>{`. The 7500 people from Reddit used theirs`}<em parentName="p">{` 362 times`}</em>{`. Promo codes made the book completely free, by the way. It's also `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/nightowls"
      }}>{`hosted in full on Github`}</a>{`, so it's not like I was forcing people to pay me money so they can read a draft of the book.`}</p>
    <p>{`The book made a total of `}<em parentName="p">{`\\`}{`\\`}{`\\`}{`\\`}{`$959.88`}</em>{` in sales, of which I get a `}<em parentName="p">{`\\`}{`\\`}{`\\`}{`\\`}{`$730.40`}</em>{` cut in royalties. Much better than going with just about any other publisher - I was recently contacted with a promise of 16% royalties. And I really have a lot to thank Leanpub for, they made publishing the book dead simple and have invested all the work in having a landing page that converts.`}</p>
    <p>{`Here's the really cool part though; out of everyone who paid, `}<strong parentName="p"><em parentName="strong">{`77%`}</em>{`*`}{`*`}</strong>{` paid more than minimal price and a whopping `}<strong parentName="p"><em parentName="strong">{`38%`}</em>{`*`}{`*`}</strong>{` more than suggested price.`}</p>
    <p>{`Great success!`}</p>
    <p><em parentName="p">{`And I can't even put a price on all the useful feedback I received.`}</em></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nathanael.hevenet.com/why-i-quit-hacker-news/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_51_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://nathanael.hevenet.com/why-i-quit-hacker-news/"
        }}>{`Why I Quit Hacker News`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.chargeback.cc/2012/11/19/use-adwords-to-find-the-best-title-for-your-hacker-news-post/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/126716812_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.chargeback.cc/2012/11/19/use-adwords-to-find-the-best-title-for-your-hacker-news-post/"
        }}>{`Use Adwords to find the best title for your Hacker News post`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jacquesmattheij.com/thank-hn-our-friend-is-safe-and-sound"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_25_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://jacquesmattheij.com/thank-hn-our-friend-is-safe-and-sound"
        }}>{`Thank HN: Our friend is safe and sound`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5694cd72-73d1-4a6a-bb87-e4fd6134663a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      